import { date } from "quasar"

export function getRandomInt(max: number, min = 0) {
  return Math.floor(Math.random() * (max - min) + min)
}

function numberOfLetters(letterCount: number) {
  let text = ""

  if (letterCount <= 0) return text

  for (let i = 0; i < letterCount; i++) {
    text += String.fromCodePoint(getRandomInt(90, 65)) // ASCII
  }

  return text
}

function numberOfNumbers(numberCount: number) {
  let text = ""

  if (numberCount <= 0) return text

  for (let i = 0; i < numberCount; i++) {
    text += getRandomInt(9).toString()
  }

  return text
}

export function getRandomID(chars?: number) {
  switch (chars) {
    // F.x "01" - Attribute set ID
    case 2:
      return numberOfNumbers(2)

    // F.x "VZ-1" - Zone ID
    case 3:
      return `${numberOfLetters(2)}-${numberOfNumbers(1)}`

    // F.x "AD-01" - Attribute ID
    case 4:
      return `${numberOfLetters(2)}-${numberOfNumbers(2)}`

    // F.x "ID-AD-1" - Layout ID
    case 5:
      return `${numberOfLetters(2)}-${numberOfLetters(2)}-${numberOfNumbers(1)}`

    // F.x "AD-CD-01" - Area ID
    case 6:
      return `${numberOfLetters(2)}-${numberOfLetters(2)}-${numberOfNumbers(2)}`

    // F.x "1278-15-10-45" - Relation ID
    case 10:
      return `${numberOfNumbers(4)}-${numberOfNumbers(2)}-${numberOfNumbers(2)}-${numberOfNumbers(
        2
      )}`

    // F.x "ElE-R-2023-002" - Relation representation
    case 11:
      return `${numberOfLetters(3)}-${numberOfLetters(1)}-${numberOfNumbers(4)}-${numberOfNumbers(
        3
      )}`

    // F.x "AD-CD-01" - Area ID
    default:
      return `${numberOfLetters(2)}-${numberOfLetters(2)}-${numberOfNumbers(2)}`
  }
}

// This is used for mock polygon data
export function getRandomCoordinates(
  latMin = -90,
  latMax = 90,
  lngMin = -180,
  lngMax = 180
): [number, number] {
  const lat = Math.random() * (latMax - latMin) + latMin
  const lng = Math.random() * (lngMax - lngMin) + lngMin

  return [lat, lng]
}

export function getTimeOfEvent(context: "today" | "recent" | "old" | "random") {
  switch (context) {
    case "today":
      return date.subtractFromDate(new Date(), { hours: getRandomInt(24) }) // less than a day old
    case "recent":
      return date.subtractFromDate(new Date(), { days: getRandomInt(7) }) // less than a week old
    case "old":
      return date.subtractFromDate(new Date(), { days: getRandomInt(365, 91) }) // more than 90 days old
    case "random":
      return date.subtractFromDate(new Date(), { days: getRandomInt(90, 7) }) // between 7-90 days old
    default:
      return date.subtractFromDate(new Date(), { days: getRandomInt(2000, 7) }) // more than a week old
  }
}
